import { useEffect } from 'react';

import Link from 'next/link';

import { scrollXComponente } from 'utils/scrollComponente';
import { theBestCategories } from 'utils/theBestCategories';

import * as S from './styles';

export default function NavigationSection() {
  useEffect(() => {
    scrollXComponente('.header-navigation-section-list');
  }, []);

  return (
    <S.Container id="navigation-section" className="header-navigation-section">
      <ul className="header-navigation-section-list">
        {theBestCategories.map((section, index) => (
          <li key={index}>
            <Link href={section.url}>
              <a className="header-navigation-section-link">
                {section.icon}
                <span>{section.name}</span>
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </S.Container>
  );
}
